import { useQuery } from '@tanstack/react-query';
import type { GeoChecklistCatalogResponse } from '@brand24-original/llm-types';
import { getGeoChecklistCatalog } from '../../../services/geo-checklist/GeoChecklistService';
import { GET_GEO_CHECKLIST_CATALOG } from '../../query/geo-checklist/keys';

/** The checklist catalog (structure + English texts). Static content — cached aggressively. */
export const useGetGeoChecklistCatalog = () => {
  const { data, isLoading } = useQuery<GeoChecklistCatalogResponse>({
    queryKey: [GET_GEO_CHECKLIST_CATALOG],
    queryFn: getGeoChecklistCatalog,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading };
};
